import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    tipoServicio: '',
    mensaje: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para enviar el formulario
    console.log(formData);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-[#8B0000] text-white py-20">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">¿Necesitas una Mudanza?</h1>
            <p className="text-xl md:text-2xl">Estamos aquí para ayudarte. Contáctanos y te daremos la mejor solución.</p>
          </div>
        </div>
      </div>

      {/* Contenido Principal */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Formulario de Contacto */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-[#8B0000] mb-6">Contáctanos</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-gray-700 font-medium mb-2">Nombre Completo</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000]"
                  required
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-2">Correo Electrónico</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000]"
                  required
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-2">Teléfono</label>
                <input
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000]"
                  required
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-2">Tipo de Servicio</label>
                <select
                  name="tipoServicio"
                  value={formData.tipoServicio}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000]"
                  required
                >
                  <option value="">Selecciona un servicio</option>
                  <option value="local">Mudanza Local</option>
                  <option value="nacional">Mudanza Nacional</option>
                  <option value="internacional">Mudanza Internacional</option>
                  <option value="embalaje">Servicio de Embalaje</option>
                </select>
              </div>

              <div>
              <label className="block text-gray-700 font-medium mb-2">Mensaje</label>
              <textarea
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                rows="4"
                maxLength={500}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000]"
                required
              ></textarea>
              <p className="text-sm text-gray-500 mt-1">{formData.mensaje.length}/500 caracteres</p>
              </div>

              <button
                type="submit"
                className="w-full bg-[#8B0000] text-white py-3 px-6 rounded-lg font-medium hover:bg-[#A52A2A] transition-colors duration-300"
              >
                Enviar Mensaje
              </button>
            </form>
          </div>

          {/* Información de Contacto y Horario de Atención */}
      <div className="space-y-10">
        {/* Bloque de contacto */}
        <div className="bg-white rounded-2xl shadow-xl p-10 border border-gray-100">
    <h2 className="text-3xl md:text-4xl font-extrabold text-[#8B0000] mb-8 text-center">
            Información de Contacto
          </h2>

    <div className="space-y-4">
     {/* Teléfono */}
      <div className="flex items-center gap-4">
        <div className="bg-[#8B0000] p-3 rounded-full shadow-md flex-shrink-0">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
        </div>
        <div>
           <h3 className="text-lg font-semibold text-gray-900 flex center">Teléfono</h3>
          <p className="text-gray-600 text-base">+56 9 1234 5678</p>
        </div>
      </div>

      {/* Email */}
      <div className="flex items-center gap-4">
        <div className="bg-[#8B0000] p-3 rounded-full shadow-md">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900 flex center">Email</h3>
          <p className="text-gray-600 text-base">contacto@frabasapp.com</p>
        </div>
      </div>

      {/* Dirección */}
      <div className="flex items-center gap-4">
        <div className="bg-[#8B0000] p-3 rounded-full shadow-md">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>
        <div>
           <h3 className="text-lg font-semibold text-gray-900 flex center">Dirección</h3>
          <p className="text-gray-600 text-base">Av. Principal 123, Santiago, Chile</p>
        </div>
      </div>
    </div>
  </div>

  {/* Bloque de horario */}
          <div className="bg-white rounded-2xl shadow-xl p-10 border border-gray-100">
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#8B0000] mb-6 text-center">
              Horario de Atención
            </h2>
            <div className="space-y-2 text-center text-gray-600 text-base">
              <p><span className="font-medium text-gray-800">Lunes a Viernes:</span> 8:00 AM - 8:00 PM</p>
              <p><span className="font-medium text-gray-800">Sábados:</span> 9:00 AM - 2:00 PM</p>
              <p><span className="font-medium text-gray-800">Domingos:</span> Cerrado</p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
